export default {
    en: {
        id: 'exercise3',
        blocks: [
            {
                title: "S = ",
                answer: ' ',
                disableEdit: true,
                hidePlaceHolder: true
            },
            {
                title: "C = ",
                answer: ' ',
                disableEdit: true,
                hidePlaceHolder: true
            },
            {
                title: "Q = ",
                answer: ' ',
                disableEdit: true,
                hidePlaceHolder: true
            }
        ],
        pyramid: {
          exerciseNumber: 3,
          pyramidHeader: 'To cut Rationalization Program to manageable size, we should implement only high benefit proposals',
          pyramidBody: [
            'Adhere to the June deadline for those projects in the present backlog that require low capital expenditure',
            'Rigorously reappraise the remaining projects in the backlog to eliminate those that will yield low benefits',
            'Set realistic deadlines for completing the second group of projects',
          ]
        },
        hideSubmit: true,
        prefilledAnswer: true
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/5/5a/defineProblem/i18n/exercise3.js